import { createPortal } from "react-dom";
import "../assets/css/global-loader.css";

export default function GlobalLoader({ isOpen }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="global-loader-overlay">
      <div className="global-loader-spinner"></div>
    </div>,
    document.body
  );
}